/* ==========================================================================
   sticky-buy.js — schmale Kaufleiste auf dem Handy (seit 3.10.26)
   --------------------------------------------------------------------------
   Markup: snippets/sticky-buy.liquid (aus sections/sticky-atc-bar.liquid),
   Optik: assets/sticky-buy.css.

   Sichtbar nur unter 768 px, sobald die Kaufbutton-Zeile des Hauptprodukts
   (.product-form__buttons) nach OBEN aus dem Bild gescrollt ist (am
   Seitenanfang, wenn sie noch unterhalb liegt, nicht). Ausloeser sind ein
   IntersectionObserver (auch Layout-Aenderungen ohne Scroll) und ein passiver,
   auf ein Frame gedrosselter Scroll-Listener: der Observer allein meldet keinen
   Sprung von "unterhalb" direkt nach "oberhalb" (z.B. Anker-Link), weil die
   Zeile dabei nie sichtbar wird. Gemessen wird bei jedem Durchlauf frisch.
   Ausgeblendet, solange etwas darueber liegt:
     - Theme-Modals und -Drawer (body.modal-show / modal-showing): Cart-Drawer,
       Fit-Quiz, Groessentabelle, Menue, Suche, Quick-View
     - Groessenwarnung (body.size-warning-modal-open)
     - Bottom-Sheet der Ankuendigungsleiste (.tos-ab-sheet ohne hidden) und jede
       andere Scroll-Sperre ueber body.overflow-hidden
     - Pandectes-Cookie-Banner (dialog[open] im Shadow Root)

   Der Button spiegelt den Haupt-Kaufbutton: sichtbarer Text 1:1 (inkl.
   "Groesse waehlen" / "Laenge waehlen" / "Groesse & Laenge waehlen" aus
   assets/size-unconfirmed.css, "In den Warenkorb legen", "Ausverkauft").
   Tipp:
     - Pflicht-Option fehlt   -> TOSSizeGate.nudge: zur ersten fehlenden Option
                                 scrollen, Hinweis, Puls (wie am Haupt-Button)
     - Variante nicht kaufbar -> zur Kaufbutton-Zeile scrollen (dort sitzt die
                                 Benachrichtigen-UI von back-in-stock.liquid)
     - sonst                  -> Klick auf den HAUPT-Button: gleiche Variante,
                                 Groessenwarnung und Cart-Drawer wie dort
   Nach einem Kauf ueber die Leiste: das Theme oeffnet den Drawer mit dem
   Haupt-Button als Fokus-Rueckgabeziel und ruft beim Schliessen focus() darauf,
   was die Seite zum Kaufbereich hochscrollt. Nur in diesem Fall wird das Ziel
   geloescht und nach dem Schliessen der Leisten-Button fokussiert (preventScroll),
   die Kundin bleibt an ihrer Stelle.
   Bewusst kein button[name="add"] und kein Formular: product-info.js schaltet
   beim Variantenwechsel alle [name="add"]-Buttons der Seite mit, und
   size-unconfirmed.js / size-warning-modal.js haengen an Produktformularen.
   ========================================================================== */
(function () {
  if (!window.customElements || window.customElements.get('sticky-buy')) return;

  var MOBILE = '(max-width: 767px)';
  // Unterkante des schwebenden Headers (mobil ca. 9-10 rem): Zeile dahinter gilt als weg.
  var TOP_EDGE = 100;

  function visibleText(btn) {
    var out = [];
    for (var i = 0; i < btn.children.length; i++) {
      var c = btn.children[i];
      if (c.tagName !== 'SPAN') continue;
      if (window.getComputedStyle(c).display === 'none') continue;
      var t = c.textContent.replace(/\s+/g, ' ').trim();
      if (t) out.push(t);
    }
    return out.join(' ');
  }

  function reducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  class StickyBuy extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-sticky-buy-btn]');
      this.label = this.querySelector('[data-sticky-buy-label]');
      this.priceEl = this.querySelector('[data-sticky-buy-price]');
      if (!this.btn || !this.label) return;

      this.past = false;
      this.shown = false;
      this.mq = window.matchMedia(MOBILE);
      this.schedule = this.schedule.bind(this);
      this.ac = new AbortController();
      var opts = { signal: this.ac.signal };

      this.btn.addEventListener('click', this.onTap.bind(this), opts);
      document.addEventListener('su:change', this.schedule, opts);
      document.addEventListener('variant:changed', this.schedule, opts);
      window.addEventListener('pageshow', this.schedule, opts);
      this.scheduleVisibility = this.scheduleVisibility.bind(this);
      window.addEventListener('scroll', this.scheduleVisibility, { signal: this.ac.signal, passive: true });
      if (this.mq.addEventListener) this.mq.addEventListener('change', this.schedule, opts);
      var fx = window.FoxTheme;
      if (fx && fx.pubsub && fx.pubsub.PUB_SUB_EVENTS) {
        this.unsubVariant = fx.pubsub.subscribe(fx.pubsub.PUB_SUB_EVENTS.variantChange, this.schedule);
      }
      // Theme-Overlays: Klassen am <body>; Drawer/Modals wandern beim Oeffnen ans <body>.
      this.bodyObserver = new MutationObserver(this.schedule);
      this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'], childList: true });
      // Cookie-Banner (Shadow DOM) und Overlays ohne eigenes Signal: leichter
      // Takt, nur solange die Leiste ueberhaupt in Frage kommt.
      var self = this;
      this.timer = window.setInterval(function () {
        if (self.past) self.schedule();
      }, 600);

      this.render();
    }

    disconnectedCallback() {
      if (this.ac) this.ac.abort();
      if (this.io) this.io.disconnect();
      if (this.mo) this.mo.disconnect();
      if (this.bodyObserver) this.bodyObserver.disconnect();
      if (this.unsubVariant) this.unsubVariant();
      window.clearInterval(this.timer);
      this.boundBtn = null;
    }

    // Hauptprodukt (nie die Quick-View-Instanz)
    productInfo() {
      var id = this.getAttribute('data-product-id');
      var list = document.querySelectorAll('product-info[data-product-id="' + id + '"]');
      for (var i = 0; i < list.length; i++) {
        if (list[i].getAttribute('data-view-mode') !== 'quick-view') return list[i];
      }
      return null;
    }

    mainButton() {
      var pi = this.productInfo();
      return pi ? pi.querySelector('form[is="product-form"] button[name="add"]') : null;
    }

    // Kaufbutton-Zeile: bleibt gleich gross, auch wenn back-in-stock.liquid den
    // Button bei ausverkaufter Variante ausblendet und "Benachrichtigen" einsetzt.
    buyRow(btn) {
      return (btn && btn.closest('.product-form__buttons')) || btn;
    }

    bind() {
      var btn = this.mainButton();
      if (btn === this.boundBtn) return;
      this.boundBtn = btn;
      if (this.io) this.io.disconnect();
      if (this.mo) this.mo.disconnect();
      this.past = false;
      this.row = null;
      if (!btn) return;

      this.row = this.buyRow(btn);
      this.io = new IntersectionObserver(this.scheduleVisibility, {
        rootMargin: '-' + TOP_EDGE + 'px 0px 0px 0px',
        threshold: 0
      });
      this.io.observe(this.row);

      this.mo = new MutationObserver(this.schedule);
      this.mo.observe(btn, { attributes: true, childList: true, subtree: true, characterData: true });
      var pi = this.productInfo();
      if (pi) {
        this.mo.observe(pi, { attributes: true, attributeFilter: ['data-su-size', 'data-su-len', 'data-su-confirmed'] });
      }
    }

    // Aktuell gewaehlte Variante aus dem sichtbaren Picker (beim Wechsel steht
    // der alte noch 500 ms mit display:none im DOM).
    variant() {
      var pi = this.productInfo();
      if (!pi) return null;
      var all = pi.querySelectorAll('variant-selects');
      for (var i = 0; i < all.length; i++) {
        if (all[i].style.display === 'none') continue;
        var s = all[i].querySelector('[data-selected-variant]');
        if (!s) return null;
        if (s === this.variantNode) return this.variantData;
        this.variantNode = s;
        try {
          this.variantData = JSON.parse(s.textContent);
        } catch (e) {
          this.variantData = null;
        }
        return this.variantData;
      }
      return null;
    }

    cookieBannerOpen() {
      var cmp = document.querySelector('pandectes-cmp');
      var root = cmp && cmp.shadowRoot;
      var d = root && root.querySelector('dialog[open]');
      if (!d) return false;
      var r = d.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    }

    blocked() {
      var cl = document.body.classList;
      if (
        cl.contains('modal-show') ||
        cl.contains('modal-showing') ||
        cl.contains('size-warning-modal-open') ||
        cl.contains('overflow-hidden')
      ) {
        return true;
      }
      if (document.querySelector('cart-drawer[open], drawer-component[open], basic-modal[open], quick-view-modal[open]')) {
        return true;
      }
      var sheet = document.querySelector('.tos-ab-sheet');
      if (sheet && !sheet.hidden) return true;
      return this.cookieBannerOpen();
    }

    renderPrice(v) {
      var fx = window.FoxTheme;
      if (!this.priceEl || !fx || !fx.Currency || !fx.settings) return;
      var key = v.id + ':' + v.price + ':' + v.compare_at_price;
      if (this.priceKey === key) return;
      this.priceKey = key;
      var fmt = fx.settings.moneyFormat;
      this.priceEl.textContent = fx.Currency.formatMoney(v.price, fmt);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        var s = document.createElement('s');
        s.textContent = fx.Currency.formatMoney(v.compare_at_price, fmt);
        this.priceEl.appendChild(s);
      }
    }

    // Nur "nach oben weggescrollt" zaehlt; ohne Groesse (ausgeblendet) nie.
    measure() {
      if (!this.row || !this.row.isConnected) {
        this.past = false;
        return;
      }
      var r = this.row.getBoundingClientRect();
      this.past = r.height > 0 && r.bottom <= TOP_EDGE;
    }

    // Leichter Pfad fuer Scroll und Observer: nur Position + Overlays.
    renderVisibility() {
      this.trackDrawer();
      this.measure();
      this.toggle(!!this.boundBtn && this.mq.matches && this.past && !this.blocked());
      this.maybeRefocus();
    }

    scheduleVisibility() {
      if (this.pendingVis || this.pending) return;
      this.pendingVis = true;
      var self = this;
      window.requestAnimationFrame(function () {
        self.pendingVis = false;
        self.renderVisibility();
      });
    }

    // Kauf ueber die Leiste -> Drawer: Fokus-Ruecksprung zum Haupt-Button verhindern.
    trackDrawer() {
      if (!this.drawerFlow) return;
      var d = document.querySelector('cart-drawer');
      var open = !!d && d.hasAttribute('open');
      if (this.drawerFlow === 'clicked' && open) {
        if ('activeElement' in d) d.activeElement = null;
        this.drawerFlow = 'open';
      } else if (this.drawerFlow === 'open' && !open) {
        this.drawerFlow = 'closed';
      }
    }

    // Nach dem Schliessen: Fokus auf den Leisten-Button, ohne zu scrollen.
    maybeRefocus() {
      if (this.drawerFlow !== 'closed' || !this.shown) return;
      this.drawerFlow = null;
      var self = this;
      var tries = 0;
      (function attempt() {
        if (!self.shown) return;
        try {
          self.btn.focus({ preventScroll: true });
        } catch (e) {}
        if (document.activeElement !== self.btn && ++tries < 6) window.setTimeout(attempt, 100);
      })();
    }

    render() {
      this.bind();
      this.trackDrawer();
      this.measure();
      var btn = this.boundBtn;
      if (btn) {
        var text = visibleText(btn);
        if (text && this.label.textContent !== text) this.label.textContent = text;
      }
      var v = this.variant();
      if (v) this.renderPrice(v);
      this.toggle(!!btn && this.mq.matches && this.past && !this.blocked());
      this.maybeRefocus();
    }

    toggle(show) {
      if (show === this.shown) return;
      this.shown = show;
      this.classList.toggle('is-visible', show);
      if (show) {
        this.removeAttribute('aria-hidden');
        this.removeAttribute('inert');
      } else {
        this.setAttribute('aria-hidden', 'true');
        this.setAttribute('inert', '');
      }
    }

    schedule() {
      if (this.pending) return;
      this.pending = true;
      var self = this;
      window.requestAnimationFrame(function () {
        self.pending = false;
        self.render();
      });
    }

    scrollToBuy(btn) {
      var target = this.buyRow(btn);
      if (target) target.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'center' });
    }

    onTap(e) {
      e.preventDefault();
      var pi = this.productInfo();
      var main = this.mainButton();
      if (!pi || !main) return;
      var gate = window.TOSSizeGate;
      // 1) Pflicht-Option fehlt: dieselbe Fuehrung wie am Haupt-Button
      if (gate && gate.isUnconfirmed(pi)) {
        gate.nudge(pi);
        return;
      }
      // 2) Nicht kaufbar (ausverkauft, nicht verfuegbar, Button gesperrt):
      //    zum Kaufbereich, dort sitzt die Benachrichtigen-UI
      var v = this.variant();
      if (!v || !v.available || main.disabled) {
        this.scrollToBuy(main);
        return;
      }
      // 3) Kauf ueber das Haupt-Formular (eine Quelle der Wahrheit)
      this.drawerFlow = 'clicked';
      var self = this;
      window.clearTimeout(this.drawerFlowTimer);
      this.drawerFlowTimer = window.setTimeout(function () {
        if (self.drawerFlow === 'clicked') self.drawerFlow = null;
      }, 15000);
      main.click();
    }
  }

  window.customElements.define('sticky-buy', StickyBuy);
})();
